const breadcrumb = {
  clients: 'Clients',
  details: 'Client Details',
  new: 'New Client',
  dictionary: 'Client Dictionary',
};

const button = {
  backToList: 'Back to List',
  createClient: 'Create Client',
  deleteClient: 'Delete Client',
  createDictionary: 'Create Dictionary',
  dictionary: 'Edit Client Dictionary',
  details: 'Client Details',
  add: 'Add',
  update: 'Update',
  back: 'Back',
};

const form = {
  clientName: "Client's name",
  description: 'Description',
  email: 'Email',
  enterDescription: 'Enter a description...',
  name: 'Name',
  irthConfig: 'IRTH configuration',
  apiKey: 'API key',
  apiUrl: 'API url',
  clientTemplate: 'Client template',
  licenseNumber: 'License number',
  key: 'Key',
  value: 'Value',
};

const message = {
  creationSuccess: 'Client created successfully',
  deletionConfirmation: 'Do you want to delete this client?',
  updateSuccess: 'Client updated successfully',
  dictionaryCreationSuccess: 'Dictionary created successfully',
  dictionaryUpdateSuccess: 'Dictionary updated successfully',
  dictionaryDeletionConfirmation: 'Do you want to delete this dictionary?',
};

export default {
  breadcrumb,
  button,
  form,
  message,
  name: 'Client Name',
  user: 'User',
  pilot: 'Pilot',
  configuration: 'Configuration',
};
